import React from 'react';
import { PAYMENT_STATES, PAYMENT_TYPES } from 'utils/Constants';

import { Button, Datepicker, Currency, Input, Select } from 'components/Misc/Form';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const Payment = ({ payment }) => {
	// Use user's creation store
	const [onChangeStudentPayment, onRemoveStudentPayment] = useUserCreateStore(state => [
		state.onChangeStudentPayment,
		state.onRemoveStudentPayment
	]);

	// Handle payment data change
	const onChange = (change) => onChangeStudentPayment(payment.gradeId, payment.key, change);

	// Handle payment removal for student
	const onRemove = () => onRemoveStudentPayment(payment.gradeId, payment.key);

	return (
		<div className="p-3 flex items-center space-x-4 border rounded-lg border-neutral-200 dark:border-neutral-700">
			<div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-4">
				<Select
					name="type"
					value={payment.type}
					onChange={onChange}
					options={PAYMENT_TYPES.map(type => ({
						value: type.value, name: type.text
					}))}
				/>

				<Currency
					name="amount"
					value={payment.amount}
					onChange={onChange}
				/>

				<Select
					name="state"
					value={payment.state}
					onChange={onChange}
					options={PAYMENT_STATES.map(state => ({
						value: state.value, name: state.text
					}))}
				/>

				<Datepicker
					end
					asInput
					name="deadlineAt"
					value={payment.deadlineAt}
					onChange={onChange}
				/>
			</div>

			<Button
				small
				square
				icon="close"
				theme="danger"
				onClick={onRemove}
			/>
		</div>
	);
};

export default Payment;